import { createContext } from 'react';

export const FALLBACK_CURRENCY = 'SAR';

type Props = {
  locale: string;
  setLocale: (locale: string) => Promise<void>;
  currentCurrency: string;
};

const LanguageContext = createContext<Props>({
  locale: '',
  setLocale: async () => {},
  currentCurrency: '',
});

export default LanguageContext;
